import React, { useEffect, useState } from "react";
import { MUIInput, PasswordField } from "../Components/MUI/Input";
import { loginUser } from "../Config/FirebaseMethod";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { Button, CircularProgress, FormHelperText } from "@mui/material";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import loginImage from "../Assets/LoginPage.png";
import TopPageButton from "../Components/TopPage/TopePage";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  let login = () => {
    setIsLoading(true);
    loginUser({ email, password }, "AneeqUllahKhan")
      .then((success) => {
        setIsLoading(false);
        if (success.category === "Admin") {
          navigate(`/admin/${success.id}`);
        } else if (success.category === "user") {
          navigate(`/user/${success.id}`);
        }
        // console.log(success);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error);
        // console.log(error);
      });
  };

  let handleSubmit = (e) => {
    e.preventDefault();
    login();
  };

  useEffect(() => {
    document.title = "Login | Aneeq Ullah Khan";
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Navbar />

      <div className="container mt-3 mb-3">
        <a id="top"></a>
        <Box>
          <br />
          <div class="shadow p-4 mb-5 bg-dark rounded">
            <div className="container mt-4">
              <h3>Please Login</h3>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="container-fluid mt-5">
                  <br />
                  <form onSubmit={handleSubmit}>
                    <MUIInput
                      variant="standard"
                      label="Email Address"
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      aria-describedby="component-error-text"
                    />
                    <FormHelperText
                      id="component-error-text"
                      sx={{ color: "red" }}
                    >
                      {error}
                    </FormHelperText>
                    <Box mt={2} />
                    <PasswordField
                      variant="standard"
                      label="Password"
                      name="password"
                      onChange={(e) => setPassword(e.target.value)}
                      aria-describedby="component-error-text"
                      required
                    />
                    <FormHelperText
                      id="component-error-text"
                      sx={{ color: "red" }}
                    >
                      {error}
                    </FormHelperText>
                    <Box mt={4} />
                    <button className="btn-login" type="submit" onClick={login}>
                      &nbsp;{isLoading ? <CircularProgress /> : "Login"}
                    </button>
                  </form>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="text-center">
                  <img src={loginImage} alt="" height="auto" width="100%" />
                </div>
              </div>
            </div>
            <br />
          </div>
        </Box>
      </div>

      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default Login;
